import { api } from "./lib/api";

type ModelTool = {
  name: string;
  title?: string;
  description: string;
  inputSchema: object;
  annotations?: { readOnlyHint?: boolean; untrustedContentHint?: boolean };
  execute(input: Record<string, unknown>): unknown | Promise<unknown>;
};

declare global {
  interface Document {
    modelContext?: {
      registerTool(tool: ModelTool, options?: { signal?: AbortSignal }): void | Promise<void>;
    };
  }
}

export function registerStudentTools(onChanged: () => void) {
  const context = document.modelContext;
  if (!context?.registerTool) return () => undefined;
  const lifecycle = new AbortController();
  const report = (error: unknown) => console.warn("WebMCP-tool kon niet worden geregistreerd", error);

  void Promise.resolve(
    context.registerTool(
      {
        name: "navigate_to_python_lesson",
        title: "Open Python-missie",
        description: "Open missie 1 tot en met 5 in de zichtbare CodeQuest-leeromgeving.",
        inputSchema: {
          type: "object",
          properties: { lessonId: { type: "integer", minimum: 1, maximum: 5 } },
          required: ["lessonId"],
          additionalProperties: false,
        },
        annotations: { readOnlyHint: true, untrustedContentHint: false },
        execute(input) {
          const lessonId = Number(input.lessonId);
          if (![1, 2, 3, 4, 5].includes(lessonId)) throw new Error("Kies missie 1 tot en met 5.");
          window.dispatchEvent(new CustomEvent("codequest:navigate", { detail: { lessonId } }));
          return { openedLesson: lessonId };
        },
      },
      { signal: lifecycle.signal },
    ),
  ).catch(report);

  void Promise.resolve(
    context.registerTool(
      {
        name: "ask_codequest_teacher",
        title: "Stel de docent een vraag",
        description: "Stuur een korte vraag over de huidige Python-missie naar de docent.",
        inputSchema: {
          type: "object",
          properties: {
            lessonId: { type: "integer", minimum: 1, maximum: 5 },
            question: { type: "string", minLength: 3, maxLength: 500 },
          },
          required: ["lessonId", "question"],
          additionalProperties: false,
        },
        annotations: { readOnlyHint: false, untrustedContentHint: true },
        async execute(input) {
          await api("questions", {
            method: "POST",
            body: JSON.stringify({ lessonId: input.lessonId, question: input.question }),
          });
          onChanged();
          return { sent: true };
        },
      },
      { signal: lifecycle.signal },
    ),
  ).catch(report);

  return () => lifecycle.abort();
}
